document.addEventListener('DOMContentLoaded', function() {
  // SLIDER
  var slides = document.querySelectorAll('.hero-slide');
  var dots = document.querySelectorAll('.slider-dot');
  if (slides.length) {
    var cur = 0, timer;
    function goTo(n) {
      slides[cur].classList.remove('active');
      if (dots[cur]) dots[cur].classList.remove('active');
      cur = (n + slides.length) % slides.length;
      slides[cur].classList.add('active');
      if (dots[cur]) dots[cur].classList.add('active');
    }
    function start() { timer = setInterval(function(){ goTo(cur+1); }, 5000); }
    slides[0].classList.add('active');
    if (dots[0]) dots[0].classList.add('active');
    start();
    dots.forEach(function(d,i){ d.addEventListener('click', function(){ goTo(i); clearInterval(timer); start(); }); });
    var prev = document.querySelector('.slider-arrow.prev');
    var next = document.querySelector('.slider-arrow.next');
    if (prev) prev.addEventListener('click', function(){ goTo(cur-1); clearInterval(timer); start(); });
    if (next) next.addEventListener('click', function(){ goTo(cur+1); clearInterval(timer); start(); });
  }

  // MOBILE NAV
  var ham = document.querySelector('.hamburger');
  var mNav = document.getElementById('mobile-nav');
  var mClose = document.querySelector('.mobile-nav-close');
  if (ham && mNav) {
    ham.addEventListener('click', function(){ mNav.classList.add('open'); });
    if (mClose) mClose.addEventListener('click', function(){ mNav.classList.remove('open'); });
  }

  // PDP THUMBNAILS
  document.querySelectorAll('.pdp-thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var mainBox = document.getElementById('pdp-main-img');
      if (!mainBox) return;
      var src = this.dataset.src;
      var emoji = this.dataset.emoji;
      if (src) mainBox.innerHTML = '<img src="'+src+'" alt="" style="width:100%;height:100%;object-fit:contain;padding:1rem;">';
      else if (emoji) mainBox.innerHTML = '<div class="pdp-emoji">'+emoji+'</div>';
      document.querySelectorAll('.pdp-thumb').forEach(function(t){ t.classList.remove('active'); });
      this.classList.add('active');
    });
  });
});

// AJAX ADD TO CART
function addToCartAjax(variantId, qty) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty || 1 })
  })
  .then(function(r){ return r.json(); })
  .then(function(item) {
    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(cart) {
        var badge = document.querySelector('.cart-count-badge');
        if (badge) badge.textContent = cart.item_count;
      });
    showOmniaToast('Added to cart: ' + item.product_title);
  })
  .catch(function(e){ console.error(e); });
}

function showOmniaToast(msg) {
  var t = document.getElementById('omnia-toast');
  if (!t) {
    t = document.createElement('div');
    t.id = 'omnia-toast';
    t.className = 'omnia-toast';
    document.body.appendChild(t);
  }
  t.textContent = '🛒 ' + msg;
  t.classList.add('show');
  setTimeout(function(){ t.classList.remove('show'); }, 3000);
}
